namespace GeniuzPOS.PosShift {
    export interface ReportSaleTaxData extends Serenity.ListRequest {
        Details?: ReportSaleTaxRow[];
        Year?: string;
        Month?: string;
        user?: string;
        username?: string;
        BizName?: string;
        ShopName?: string;
        ShopAddress?: string;
        ShopTaxId?: string;
        BranchName?: string;
    }
}
